const { ccclass, property } = cc._decorator;
import YXXuModelBase from "./yxx_table_model_base";

@ccclass
export default class YXXuModel extends YXXuModelBase {


}